import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import CatalogueExplorer from '@/components/catalogue/explorer/CatalogueExplorer';
import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import SiChevronLeft from '@/icons/SiChevronLeft';
import { useCurrentPurchaseOrderLink } from '@/lib/getMyLinks';
import { useCompanySelectedProducts } from '@/services/api/hooks/companies';
import { useCatalogueRoutePrefix } from '@/services/catalogue/useCatalogueRoutePrefix';
import { usePoName } from '@/services/purchaseOrders/usePurchaseOrderService';
import { usePONavigateAndValidate } from '@/services/purchaseOrders/validation/purchaseOrderHooks';
import { FC } from 'react';
import { useParams } from 'react-router';
import SavePurchaseOrderButton from './SavePurchaseOrder';

export const PurchaseOrderStandardisedProducts: FC = () => {
  const { orderId, companyId, partnerId } = useParams();

  if (!companyId) {
    throw Error('Company ID not defined');
  }

  const navigateAndValidate = usePONavigateAndValidate();

  const poLink = useCurrentPurchaseOrderLink();

  const poName = usePoName();
  const nameToDisplay = poName || 'Create';

  const breadcrumbs: NavPage[] = [
    {
      name: 'Orders / Quotes',
      to: poLink
    },
    {
      name: nameToDisplay,
      to: `${poLink}/${orderId}/poCatalogue`
    },
    {
      name: 'Standardised Products',
      to: `${poLink}/${orderId}/poCatalogue/standardisedProducts`
    }
  ];

  const routePrefix = useCatalogueRoutePrefix();

  const selectedProductIds = useCompanySelectedProducts(companyId, partnerId);

  return (
    <>
      <CatalogueExplorer
        productIds={selectedProductIds}
        showCategories={false}
        header={{
          step: 1,
          title: nameToDisplay,
          subtitle: `Standardised Products`,
          breadcrumbs,
          controls: (
            <>
              {/*<HelpButton />*/}
              <Button onClick={() => navigateAndValidate(`${routePrefix}/poCatalogue`)} variant={ButtonVariant.Mono}>
                <SiChevronLeft className="text-xl" />
                <span>Back to full catalogue</span>
              </Button>
              <Button
                variant={ButtonVariant.Secondary}
                onClick={() => {
                  navigateAndValidate(`${routePrefix}/poCatalogue/selectedProducts`);
                }}
              >
                My Order
              </Button>
              <SavePurchaseOrderButton />
              <Button
                variant={ButtonVariant.Primary}
                onClick={() => navigateAndValidate(`${routePrefix}/poCatalogue/deliveryDetails`)}
              >
                Set Delivery Details
              </Button>
            </>
          )
        }}
        navigate={navigateAndValidate}
      />
    </>
  );
};
